import type { AutoAriaLabelElementProps } from "../common/customElement/extend.useOcAutoAriaLabel";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const unmaskElement = (ev: Event): void => {
  /*                                                                    */
  const elements = ev.composedPath() as (HTMLElement & AutoAriaLabelElementProps)[];
  const element = elements.find((el) => el?.dataset?.maskedRef);

  if (!element) return;

  const maskedRef = element.dataset.maskedRef;
  if (!maskedRef) return;

  const decodedHref = atob(maskedRef);

  /*                                                                            */
  if (element instanceof HTMLAnchorElement) {
    element.href = decodedHref;
    delete element.dataset.maskedRef;
    return;
  }

  /*                                                                      */
  const anchorElement: HTMLAnchorElement & AutoAriaLabelElementProps = document.createElement("a");

  /*                                                                      */
  Array.from(element.attributes)
    .filter((attr) => attr.name !== "data-masked-ref")
    .forEach(({ name, value }) => anchorElement.setAttribute(name, value));

  /*                                                                               */
  anchorElement.__ocAutoAriaLabel = element.__ocAutoAriaLabel;

  /*                                                              */
  anchorElement.href = decodedHref;

  /*                                                  */
  anchorElement.append(...element.childNodes);

  /*                                                                      */
  element.parentNode?.replaceChild(anchorElement, element);

  /*                                                                 */
  if (ev instanceof FocusEvent) {
    anchorElement.focus();
  }
};
